export const company = {
  name: "STARLINK Security & Facilities",
  legalName: "STARLINK Security & Facilities Pvt. Ltd.",
  tagline: "Security · Housekeeping · Events · Valet",
  phone: "+91 7416064672",
  phone2: "+91 40-45556423",
  email: "info@starlinksecurityforce.com",
  address: "Narsingi, Hyderabad, Telangana - 500075",
  instagram: "https://www.instagram.com/starlink_security_forcepvt.ltd",
  facebook: "#",
  linkedin: "#",
};

export const images = {
  team: "/assets/hero-team.jpg",
  hero: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob3VzZWtlZXBpbmclMjBtb2Rlcm4lMjBjbGVhbiUyMGludGVyaW9yfGVufDB8fHx8MTc4ODY5MDUxOHww&ixlib=rb-4.1.0&q=85",
  security: "https://images.unsplash.com/photo-1485230405346-71acb9518d9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGd1YXJkJTIwYnVpbGRpbmclMjBsdXh1cnklMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzg4NjkwNTE4fDA&ixlib=rb-4.1.0&q=85",
  security2: "https://images.unsplash.com/photo-1566245024852-04fbf7842ce9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxzZWN1cml0eSUyMGd1YXJkJTIwYnVpbGRpbmclMjBsdXh1cnklMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzg4NjkwNTE4fDA&ixlib=rb-4.1.0&q=85",
  housekeeping: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3VzZWtlZXBpbmclMjBtb2Rlcm4lMjBjbGVhbiUyMGludGVyaW9yfGVufDB8fHx8MTc4ODY5MDUxOHww&ixlib=rb-4.1.0&q=85",
  housekeeping2: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3VzZWtlZXBpbmclMjBtb2Rlcm4lMjBjbGVhbiUyMGludGVyaW9yfGVufDB8fHx8MTc4ODY5MDUxOHww&ixlib=rb-4.1.0&q=85",
  events: "https://images.unsplash.com/photo-1522255272218-7ac5249be344?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBldmVudCUyMGdhbGElMjB2YWxldCUyMGx1eHVyeSUyMGNhcnxlbnwwfHx8fDE3ODg2OTA1MTh8MA&ixlib=rb-4.1.0&q=85",
  valet: "https://images.unsplash.com/photo-1627285886624-5cd637dafb50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBldmVudCUyMGdhbGElMjB2YWxldCUyMGx1eHVyeSUyMGNhcnxlbnwwfHx8fDE3ODg2OTA1MTh8MA&ixlib=rb-4.1.0&q=85",
};

export const services = [
  {
    id: "security",
    num: "01",
    title: "Security Operations",
    tagline: "Tactical perimeter & executive protection",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Licensed officers, surveillance integration and 24/7 patrol telemetry keep people and assets protected around the clock.",
    bullets: ["Licensed & vetted officers", "24/7 patrol telemetry", "CCTV & access control integration", "Threat assessment matrix"],
    image: "/assets/service-security.jpg",
  },
  {
    id: "housekeeping",
    num: "02",
    title: "Housekeeping & Facility Care",
    tagline: "Hospitality-grade architectural upkeep",
    desc: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Hospitality-grade clean room standards, sustainable eco-chemical protocols and marble surface care.",
    bullets: ["Hospitality-grade standards", "Eco-certified chemicals", "Scheduled deep sanitization", "Marble & surface care"],
    image: "/assets/service-housekeeping.jpg",
  },
  {
    id: "events",
    num: "03",
    title: "Event Management",
    tagline: "Flawless logistics, summits & galas",
    desc: "Ut enim ad minim veniam, quis nostrud exercitation ullamco. Crowd flow orchestration, stage & AV coordination and turn-key venue readiness from first walkthrough to final teardown.",
    bullets: ["Crowd flow orchestration", "Stage & AV coordination", "Dignitary escort protocols", "Turn-key venue readiness"],
    image: "/assets/service-events.jpg",
  },
  {
    id: "valet",
    num: "04",
    title: "Valet Parking Service",
    tagline: "White-glove arrival experiences",
    desc: "Duis aute irure dolor in reprehenderit in voluptate. Digital ticket retrieval, luxury vehicle handling protocols and high-throughput ingress and egress management.",
    bullets: ["Digital ticket retrieval", "Luxury vehicle handling", "EV charging staging", "High-throughput flow management"],
    image: "/assets/service-valet.jpg",
  },
];

export const marqueeItems = [
  "24/7 Support",
  "Your Safety, Our Priority",
  "Customise Solutions",
  "PASARA Registered",
  "CAPSI Registered",
];

export const stats = [
  { value: "99.9%", label: "Protocol uptime" },
  { value: "450+", label: "Enterprise assets managed" },
  { value: "<3 min", label: "Rapid response dispatch" },
];

export const faqs = [
  {
    q: "What are your SLA response times?",
    a: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Emergency dispatch averages under three minutes, and standard requests are acknowledged within one business hour.",
  },
  {
    q: "Can staffing be customized per site?",
    a: "Sed do eiusmod tempor incididunt ut labore. Every deployment begins with a site audit, after which we build a staffing matrix matched to your floor plan, footfall and risk profile.",
  },
  {
    q: "Do you offer multi-site bundling?",
    a: "Ut enim ad minim veniam. Yes — portfolios with multiple properties receive unified command-center reporting, consolidated billing and bundled pricing across all four service lines.",
  },
  {
    q: "Are your teams insured and certified?",
    a: "Duis aute irure dolor in reprehenderit. All officers and crew are fully licensed, background-checked and insured, with ISO 9001 certified operating procedures.",
  },
];
